var Backbone = require('backbone');


var Result = Backbone.Model.extend({
    
});


module.exports = Result;



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/reserva/engine/Result.js
 **/